import NotFound from './views/NotFound.vue';

const routes = [
  {
    path: '*',
    component: NotFound,
    meta: { layout: 'empty' },
  },
];

export default routes;
